module.exports = __webpack_public_path__ + "img/check-email.59ccb283.svg";